import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as commonActions from '../../../../app/common/common.action';
import { Row, Col, FormGroup, Label, Button, Progress, Input, Modal, ModalHeader, ModalBody } from 'reactstrap';
import DateInput from '../../../../componentes/datepicker/react-datepicker.component';
import CitologiaApi from '../../../citologia/content/citologia.api';
import WebapiCommon from '../../../../app/common/util/webapi.common';
import IntlMessage from '../../../../helpers/intlMessage';

class DelegacaoConsultaComponent extends Component {
    constructor() {
        super();
        this.state = {
            data: new Date().toISOString().slice(0, 10),
            citotecnicos: [],
            ordenacao: 0,
            limiteLaminasDelegadas: 23,
            showDetalhesLaminasDelegadasCitoId: null,
            showDetalhesLaminasDelegadasCitoNome: null,
            laminas: []
        }
    }

    componentDidMount() {
        WebapiCommon.getConfiguracaoMapaMacroscopico().then((res) => {
            this.setState({
                limiteLaminasDelegadas: res
                    .configuracoesMapaMacroscopicoItems
                    .find(el => el.coluna === 'Limitelaminas').valor
            });
        })
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.ordenacao !== prevState.ordenacao) {
            this.obterCitotecnicos();
        }
    }

    render() {
        const {
            data,
            citotecnicos,
            ordenacao,
            limiteLaminasDelegadas,
            showDetalhesLaminasDelegadasCitoId,
            showDetalhesLaminasDelegadasCitoNome,
            laminas
        } = this.state;

        return (
            <div>
                <Row>
                    <Modal style={{ maxWidth: '1020px' }} centered isOpen={showDetalhesLaminasDelegadasCitoId !== null} toggle={() => this.showDetalhesLaminasDelegadas(null, null)}>
                        <ModalHeader toggle={() => this.showDetalhesLaminasDelegadas(null, null)}>
                            {`${ this.props.intl.formatMessage({id:"dashboards.histology.detailsCytotechnicianDelegation"}) } ${showDetalhesLaminasDelegadasCitoNome}`}
                        </ModalHeader>
                        <ModalBody>
                            <ul style={{ listStyle: 'none', padding: 0 }}>
                                <li>
                                    <Row style={{ fontWeight: 700, marginBottom: '5px' }}>
                                        <Col className="w90"><IntlMessage id="dashboards.histology.exam"/></Col>
                                        <Col className="w90"><IntlMessage id= 'dashboards.general.report'/></Col>
                                        <Col sm={2}><IntlMessage id='dashboards.examDetail.blade'/></Col>
                                        <Col sm={1}><IntlMessage id='dashboards.examDetails.quantity'/></Col>
                                        <Col sm={3}><IntlMessage id='dashboards.reports.type'/></Col>
                                        <Col sm={2}><IntlMessage id='dashboards.cytology.origin'/></Col>
                                        <Col sm={1}><IntlMessage id='dashboards.histology.delegation'/></Col>
                                    </Row>
                                </li>
                                {
                                    laminas.map((la) => (
                                        <li>
                                            <Row>
                                                <Col className="w90">{la.exame}</Col>
                                                <Col className="w90">{la.laudo}</Col>
                                                <Col sm={2}>{la.lamina}</Col>
                                                <Col sm={1}>{la.qtdlaminas}</Col>
                                                <Col sm={3}>{la.nome}</Col>
                                                <Col sm={2}>{la.tipoLamina}</Col>
                                                <Col sm={1}>{la.delegacao}</Col>
                                            </Row>
                                        </li>
                                    ))
                                }
                            </ul>
                        </ModalBody>
                    </Modal>
                    <Col sm={'2'}>
                        <FormGroup>
                            <Label><IntlMessage id="general.requestsPanel.date"/></Label>
                            <DateInput
                                value={data}
                                onChange={(e) => this.setState({ data: e })}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm="auto">
                        <Button
                            className="delegacao-consulta-pesquisar"
                            color="info"
                            onClick={this.obterCitotecnicos.bind(this)}
                            disabled={!data}>
                            <IntlMessage id='dashboards.cytology.search'/>
                        </Button>
                    </Col>
                    <Col>
                        <FormGroup check inline className="mt-35">
                            <Label check>
                            <IntlMessage id='dashboards.general.orderBy'/>
                            </Label>
                        </FormGroup>
                        <FormGroup check inline className="mt-35">
                            <Label check>
                                <Input
                                    type="radio"
                                    checked={ordenacao === 1}
                                    onClick={() => this.setState({ ordenacao: 1 })}
                                /> <IntlMessage id='dashboards.cytology.cytotechnician'/>
                            </Label>
                        </FormGroup>
                        <FormGroup check inline className="mt-35">
                            <Label check>
                                <Input
                                    type="radio"
                                    checked={ordenacao === 0}
                                    onClick={() => this.setState({ ordenacao: 0 })}
                                /> <IntlMessage id='dashboards.cytology.delegatedBlades'/>
                            </Label>
                        </FormGroup>
                        <FormGroup check inline className="mt-35">
                            <Label check>
                                <Input
                                    type="radio"
                                    checked={ordenacao === 2}
                                    onClick={() => this.setState({ ordenacao: 2 })}
                                /> <IntlMessage id='dashboards.cytology.remainingBlades'/>
                            </Label>
                        </FormGroup>
                    </Col>
                </Row>
                <br />
                <Row>
                    <Col>
                        <Row className="delegacao-laminas-cito-thead">
                            <Col className={"largura-col-codigo"}><IntlMessage id='dashboards.cytology.code'/></Col>
                            <Col><IntlMessage id='dashboards.cytology.cytotechnician'/></Col>
                            <Col><IntlMessage id='dashboards.cytology.delegatedBlades'/></Col>
                        </Row>
                        <div className="delegacao-laminas-cito-tbody" style={{ position: 'relative' }}>
                            {
                                citotecnicos.map((cito) => (
                                    <Row key={cito.id} style={{ marginBottom: '3px' }}>
                                        <Col className={"largura-col-codigo"}>{cito.id}</Col>
                                        <Col>{cito.citotecnico}</Col>
                                        <Col>
                                            <Progress multi onClick={() => this.showDetalhesLaminasDelegadas(cito.id, cito.citotecnico)}>
                                                <Progress bar color="success" value={cito.laminasDelegadas} max={limiteLaminasDelegadas}>
                                                    {cito.laminasDelegadas}
                                                </Progress>
                                                <Progress bar color="danger" value={limiteLaminasDelegadas - cito.laminasDelegadas} max={limiteLaminasDelegadas}>
                                                    {limiteLaminasDelegadas - cito.laminasDelegadas}
                                                </Progress>
                                            </Progress>

                                        </Col>
                                    </Row>
                                ))
                            }
                        </div>
                    </Col>
                </Row>
            </div>
        )
    }

    obterCitotecnicos() {
        const { data, ordenacao } = this.state;
        this.props.commonActions.showFadeCarregando(true);
        CitologiaApi.obterCitotecnicos(data, ordenacao).then((res) => {
            this.setState({ citotecnicos: res });
            this.props.commonActions.showFadeCarregando(false);
        })
    }

    showDetalhesLaminasDelegadas = (citoId, citoNome) => {
        if (citoId === null) {
            this.setState({
                showDetalhesLaminasDelegadasCitoId: citoId,
                showDetalhesLaminasDelegadasCitoNome: citoNome,
                laminas: []
            })
        } else {
            let { data } = this.state;
            this.props.commonActions.showFadeCarregando(true);
            CitologiaApi.obterLaminaCitologiaConsultaDetalhes(data, citoId).then((res) => {
                this.setState({
                    showDetalhesLaminasDelegadasCitoId: citoId,
                    showDetalhesLaminasDelegadasCitoNome: citoNome,
                    laminas: res
                });
                this.props.commonActions.showFadeCarregando(false);
            });
        }
    };
}

const mapDispatchToProps = (dispatch) => {
    return {
        commonActions: bindActionCreators(commonActions, dispatch)
    }
}

export default connect(null, mapDispatchToProps)(DelegacaoConsultaComponent);


// WEBPACK FOOTER //
// ./src/pages/histologia/common/delegacao_laminas/delegacao.consulta.component.js